import { render, staticRenderFns } from "./remote.vue?vue&type=template&id=226b9f24&scoped=true&lang=pug&"
import script from "./remote.vue?vue&type=script&lang=js&"
export * from "./remote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b9f24",
  null
  
)

export default component.exports